import gql from 'graphql-tag'

export const listProducts = gql`
	fragment listProducts on ProductConnection {
		items {
			name
			id
			code
			checkOutCommandId
			isActive
			price
			priceInCafe
			FA_ProductId
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
		hasNextPage
		total
	}
`

export const productRequired = gql`
	fragment productRequired on Product {
		id
		mod_ver
		name
		checkOutCommandId
	}
`

export const productMain = gql`
	fragment productmain on Product {
		code
		name
		isActive
		altName
		categoryId
		nestedCategoryId
		salesGroupId
		unitSellCode
		isNetto
		isNettoForUser
		isEmployeeArticle
		price
		priceInCafe
		codeMWSt
		codeMWSt2
	}
`

export const options = gql`
	fragment options on Product {
		linkExpense
		waste
		isWarehouse
		halfNotAllowed
		checkOutCommandId
		group1Id
		group2Id
		group3Id
	}
`

export const properties = gql`
	fragment properties on Product {
		properties {
			Font
			FontSize
			FontStyle
			Color
			ColorFont
			YouthProtection
			MDEBatchSize
			RetoureMehrereTage
			#	KitchenReportOnlyOverMenu
			SCOProductTimeSlot
			SCOFoodTray
			SCOKitchenComponent
			ClickCollectOrderMin
			ClickCollectOrderMax
			ClickCollectLeadDaysCount
			storageType
		}
	}
`

export const categoriesProperties = gql`
	fragment categoriesProperties on Product {
		properties {
			isLactoseFree
			isAlcohol
			isBio
			isVegan
			isVegetarian
			isNoGluten
			isDinkel
			isContainGluten
		}
	}
`

export const ingredients = gql`
	fragment ingredients on Product {
		ingredients {
			id
			amount
			contains
			ingredientId
			ingredient {
				id
				uuid
				name
				group
				code
				units
				keyword
			}
		}
	}
`
export const ingredientsGeneral = gql`
	fragment ingredientsGeneral on Product {
		weight
		altLabel
		description(type: htmlWeb)
		storage
		consumptionInfo
		application
		sellUp
		toMoveTill
		shelfLife
		daysToConsume
		mustBeKeptCool
		linkLabelGroup
		FA_ProductId
		RA_RecipeId
		RA_Recipe {
			id
			name
			sellUp
			toMoveTill
			shelfLife
			shelfLifeInCool
			mustBeKeptCool
			storage
			consumptionInfo
			application
			weight
			calculatedVals {
				declaration
				nutrients {
					amount
					ingredientUUID
					ingredient {
						id
						name
						group
						code
						units
					}
				}
				allergens {
					contains
					allergenUUID
					allergen {
						id
						name
						code
					}
				}
			}
		}
	}
`

export const lists = gql`
	fragment lists on Product {
		lists {
			id
			productListId
		}
	}
`

export const intervals = gql`
	fragment intervals on Product {
		intervals {
			id
			type
			dateInterval {
				from
				to
			}
			weekDays
			cashRegisterId
			description
			replay
		}
	}
`

export const concepts = gql`
	fragment concepts on Product {
		concepts {
			dbIndex
			name
			productName
			nameInOrder
			prices
			buttonCaption
			application
		}
	}
`

// export const selfCheckout = gql`
// 	fragment selfCheckout on Product {
// 		SCOFoodTray
// 		SCOKitchenComponent
// 	}
// `

export const restaurant = gql`
	fragment restaurant on Product {
		isKitchenInfo
		# isKitchenSplit
		isPrintOnlyInCafe
		isAdditionRequired
		# isScreenKeyboard
		# rdermanListName
		# isOrdermanKitchenAmount
		isServiceCall
		# isServiceCallOrderman
		#	printReceipt
		printerLocations
		#	serviceCallPrinters
		isOrdering
		additions {
			id
			mod_ver
			productAddionId
		}
		properties {
			isPrintOnAnnouncement
			isQuickAdd
		}
	}
`

export const productGrid = gql`
	fragment productGrid on Product {
		id
		name
		code
		isActive
		salesGroupId
		salesGroup {
			id
			name
		}
		unitSellCode
		categoryId
		category {
			id
			name
		}
		price
		priceInCafe

		codeMWSt
		EANCode
	}
`
